/**
 * PATH: apps/quote/src/components/builder/units.ts
 * PURPOSE: Shared unit options for quote line items.
 */

export const UNIT_OPTIONS: Array<{ value: string; label: string }> = [
  { value: 'm2', label: 'm²' },
  { value: 'lm', label: 'LM' },
  { value: 'unit', label: 'Unit' },
  { value: 'lot', label: 'Lot' },
  { value: 'day', label: 'Day' },
  { value: 'hr', label: 'Hr' },
]


